import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetData_queue = z.any()
export type TagsGetData_queue = z.infer<typeof tagsGetData_queue>

export const descriptionGetData_queue = z.any()
export type DescriptionGetData_queue = z.infer<typeof descriptionGetData_queue>

export const querystringGetData_queue = z.object({ "buildingId": z.string().optional() })
export type QuerystringGetData_queue = z.infer<typeof querystringGetData_queue>

export const responseGetData_queue = z.object({ "payload": z.array(z.object({ "createdAt": z.string().datetime({ offset: true }), "buildingId": z.string(), "collectionPointId": z.string().optional(), "submeterId": z.string().optional(), "type": z.string(), "id": z.string() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetData_queue = z.infer<typeof responseGetData_queue>

interface IGetData_queue extends BaseMethodType {
  tags: TagsGetData_queue,
  description: DescriptionGetData_queue,
  querystring: QuerystringGetData_queue,
  response: ResponseGetData_queue
}
export const URL = '/data-queue'
export const validation = {
  get: {
    tags: tagsGetData_queue,
    description: descriptionGetData_queue,
    querystring: querystringGetData_queue,
    response: responseGetData_queue
  }
}
export interface Data_queue extends BaseRouteType {
  get: IGetData_queue
}